"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

import type { Nullish } from "~/@types/generics"
import {
  container as containerStyle,
  form as formStyle,
  title as titleStyle,
} from "~/components/ui/Account/components/UnloggedTemplate/styles.css"
import { SubFormMentions } from "~/components/ui/SubFormMentions"
import RegisterFormTemplate from "~/components/forms/RegisterForm"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { useInternalRedirects } from "~/providers/InternalRedirectsProvider/index.client"

function ClientRegisterTemplate({ title }: { title: Nullish<string> }) {
  const [redirects] = useInternalRedirects()
  const router = useRouter()
  const t = useTranslate()
  const ctaProps = {
    href: redirects?.login?.href,
    children: t("account_log_in"),
  }

  useEffect(() => {
    redirects?.accountHome?.href && router.prefetch(redirects.accountHome.href)
  }, [])

  return (
    <>
      <div className={containerStyle}>
        <h1 className={titleStyle}>{title}</h1>
        <RegisterFormTemplate className={formStyle} onSuccess={() => router.push(redirects?.login?.href ?? "")} />
        <SubFormMentions title={t("account_already_have_account")} ctaProps={ctaProps} />
      </div>
    </>
  )
}

export { ClientRegisterTemplate }
